import React, { Fragment } from 'react'
import SiteHeader from '../../../components/SiteHeader';
import Breadcumb from '../../../components/Breadcumb'
import FooterArea from '../../../components/FooterArea'
import Form from '../../../components/Form'
import Seo from '../../../components/Seo'
import { breadcrumbSchema } from '../../../seo/config'
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaWhatsapp } from 'react-icons/fa'
// images
import breadcumb from '../../../images/breadcumb/contact.jpeg'

import './style.scss'

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Contact' },
]

const ContactPage = () => {
    return (
        <Fragment>
            <Seo
                title="Contact Us — Book a Consultation with Legal Corridor"
                description="Contact Legal Corridor's advocates in Delhi. Call +91 95556 90946 or send a message to book a legal consultation. We respond within 24 hours."
                path="/contact"
                schema={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Contact', path: '/contact' }])]}
            />
            <SiteHeader />
            <main>
            <Breadcumb
                className="breadcumbArea"
                title="Contact Us"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />

            <div className="contactusPageArea">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="contactUsInfo">
                                <div className="infoHeader">
                                    <span className="subTitle">Get In Touch</span>
                                    <h2>We're Here To Help</h2>
                                    <p>Have a legal question? Reach out to us and we'll get back to you within 24 hours.</p>
                                </div>

                                <div className="contactCards">
                                    <div className="contactCard">
                                        <div className="cardIcon">
                                            <FaMapMarkerAlt />
                                        </div>
                                        <div className="cardContent">
                                            <h4>Office Address</h4>
                                            <p>40, Hanuman Lane, 2nd Floor,<br />Baba Kharak Singh Marg,<br />Connaught Place, New Delhi-110001</p>
                                        </div>
                                    </div>

                                    <div className="contactCard">
                                        <div className="cardIcon">
                                            <FaPhone style={{ transform: 'scaleX(-1)' }} />
                                        </div>
                                        <div className="cardContent">
                                            <h4>Phone Number</h4>
                                            <p><a href="tel:+919555690946">+91-9555 690 946</a></p>
                                            <p><a href="tel:+917905705906">+91-7905 705 906</a></p>
                                        </div>
                                    </div>

                                    <div className="contactCard">
                                        <div className="cardIcon">
                                            <FaEnvelope />
                                        </div>
                                        <div className="cardContent">
                                            <h4>Email Address</h4>
                                            <p><a href="mailto:contact@legalcorridors.com">contact@legalcorridors.com</a></p>
                                            <p><a href="mailto:legalcorridor@gmail.com">legalcorridor@gmail.com</a></p>
                                        </div>
                                    </div>

                                    <div className="contactCard">
                                        <div className="cardIcon">
                                            <FaClock />
                                        </div>
                                        <div className="cardContent">
                                            <h4>Working Hours</h4>
                                            <p>Mon - Sat: 10:00 AM - 7:00 PM</p>
                                            <p>Emergency: 24/7 Available</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="whatsappCta">
                                    <a href="https://wa.me/919555690946" target="_blank" rel="noopener noreferrer">
                                        <FaWhatsapp />
                                        <span>Chat on WhatsApp</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="contactUSForm">
                                <div className="formHeader">
                                    <span className="subTitle">Schedule a Consultation</span>
                                    <h3>Request a Callback</h3>
                                    <p>Fill out the form below and our team will get back to you within 24 hours.</p>
                                </div>
                                <Form addressInfo={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map Section */}
            <div className="mapSection">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.6743744856584!2d77.2067168!3d28.6344091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd37b741d057%3A0xcdee88e47393c3f1!2sConnaught%20Place%2C%20New%20Delhi%2C%20Delhi%20110001!5e0!3m2!1sen!2sin!4v1704900000000!5m2!1sen!2sin"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title="Legal Corridor Office Location"
                ></iframe>
            </div>
            </main>
            <FooterArea />
        </Fragment>
    )
}
export default ContactPage